import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "none" }, [
      _createElementVNode("path", {
        stroke: "#37454D",
        d: "m9.9 1.5 8 14a1 1 0 0 1-.9 1.6H1a1 1 0 0 1-.9-1.5l8-14.1a1 1 0 0 1 1.8 0z",
        class: "background"
      }),
      _createElementVNode("path", {
        fill: "#37454D",
        d: "M7.8 14.3c0 .6.5 1.2 1.2 1.2s1.3-.6 1.3-1.3c0-.6-.6-1.2-1.3-1.2s-1.3.6-1.3 1.3z"
      }),
      _createElementVNode("rect", {
        width: "2",
        height: "7",
        x: "8",
        y: "5",
        fill: "#37454D",
        rx: "1"
      })
    ], -1)
  ]))]))
}
export default { render: render }